<div class="panel panel-default">
    <div class="panel-heading">Sampling Report</div>
    <div class="panel-body">
        <form class="form-horizontal" [formGroup]="rootForm">

            <div class="form-group" [class.has-error]="rootForm.errors?.plantingDateRangeInvalid">
              <label class="control-label col-sm-4 col-md-2">Planting Date Range</label>
              <span class="col-sm-3">
                <input 
                  type="text" 
                  class="form-control"
                  bsDaterangepicker
                  ce-date-range-picker
                  [formControl]="plantingDateRangeFormControl"
                  #plantingDateRangePicker="bsDaterangepicker" 
                />
              </span>
              <i class="fa fa-calendar fa-2x" aria-hidden="true" (click)="plantingDateRangePicker.show()"></i>
            </div>
      
            <div class="form-group" [class.has-error]="rootForm.errors?.samplingDateRangeInvalid">
              <label class="control-label col-sm-4 col-md-2">Sampling Date Range</label>
              <span class="col-sm-3">
                <input 
                  type="text" 
                  class="form-control"
                  bsDaterangepicker
                  ce-date-range-picker
                  [formControl]="samplingDateRangeFormControl"
                  #samplingDateRangePicker="bsDaterangepicker" 
                />
              </span>
              <i class="fa fa-calendar fa-2x" aria-hidden="true" (click)="samplingDateRangePicker.show()"></i>
            </div>
          
            <div class="form-group" [class.has-error]="cropFormControl.invalid">
                <label class="control-label col-sm-4 col-md-2">Crop</label>
                <div class="col-sm-8">
                  <select class="form-control" [formControl]="cropFormControl">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let crop of crops" [ngValue]="crop.id">
                      {{ crop.name }}
                    </option>
                  </select>
                </div>
            </div>
          
            <div class="form-group" [class.has-error]="laboratoryFormControl.invalid">
                <label class="control-label col-sm-4 col-md-2">Laboratory</label>
                <div class="col-sm-8">
                  <select class="form-control" [formControl]="laboratoryFormControl">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let laboratory of laboratories" [ngValue]="laboratory.id">
                      {{ laboratory.name }}
                    </option>
                  </select>
                </div>
            </div>

            <div class="form-group" [class.has-error]="laboratoryAssayFormControl.invalid">
              <label class="control-label col-sm-4 col-md-2">Assay Type</label>
              <div class="col-sm-8">
                <select class="form-control" [formControl]="laboratoryAssayFormControl">
                  <option [ngValue]="null"></option>
                  <option *ngFor="let laboratoryAssay of laboratoryAssays" [ngValue]="laboratoryAssay.id">
                    {{ laboratoryAssay.name }}
                  </option>
                </select>
              </div>
            </div>
          
        <div class="form-group" [class.has-error]="growthStageFormControl.invalid">
          <label class="control-label col-sm-4 col-md-2">Growth Stage</label>
          <div class="col-sm-8">
            <select class="form-control" [formControl]="growthStageFormControl">
              <option [ngValue]="null"></option>
              <option *ngFor="let growthStage of growthStages" [ngValue]="growthStage.id">
                {{ growthStage.name }}
              </option>
            </select>
          </div>
        </div>
      </form>
          
      <div class="col-sm-offset-4 col-md-offset-2 col-sm-8">
        <button type="button" class="btn btn-primary pull-right" [disabled]="rootForm.invalid" (click)="generateReport()">Get Report</button>
      </div>
    </div>
</div>  


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/sampling-report-form/sampling-report-form.component.html